/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChangeTaskStatusRequestDto } from '../models';
// @ts-ignore
import type { CreateTaskRequestDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { ResourceTypeDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
// @ts-ignore
import type { TaskDetailDto } from '../models';
// @ts-ignore
import type { TaskListResponseDto } from '../models';
// @ts-ignore
import type { TaskStatusChangeDto } from '../models';
// @ts-ignore
import type { TaskStatusDto } from '../models';
// @ts-ignore
import type { TaskTriggerDto } from '../models';
/**
 * TasksApi - axios parameter creator
 * @export
 */
export const TasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Zmienia status zadania i dopisuje wpis do historii (kto, kiedy, poprzedni→nowy, opcjonalny komentarz). 
         * @summary Change task status
         * @param {number} taskId 
         * @param {ChangeTaskStatusRequestDto} changeTaskStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeTaskStatus: async (taskId: number, changeTaskStatusRequestDto: ChangeTaskStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('changeTaskStatus', 'taskId', taskId)
            // verify required parameter 'changeTaskStatusRequestDto' is not null or undefined
            assertParamExists('changeTaskStatus', 'changeTaskStatusRequestDto', changeTaskStatusRequestDto)
            const localVarPath = `/api/v2/tasks/{taskId}/status`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeTaskStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a task
         * @param {CreateTaskRequestDto} createTaskRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask: async (createTaskRequestDto: CreateTaskRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTaskRequestDto' is not null or undefined
            assertParamExists('createTask', 'createTaskRequestDto', createTaskRequestDto)
            const localVarPath = `/api/v2/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a task
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTask: async (taskId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('deleteTask', 'taskId', taskId)
            const localVarPath = `/api/v2/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get task detail
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskById: async (taskId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getTaskById', 'taskId', taskId)
            const localVarPath = `/api/v2/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get task status change history
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskStatusHistory: async (taskId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getTaskStatusHistory', 'taskId', taskId)
            const localVarPath = `/api/v2/tasks/{taskId}/status-history`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of tasks matching the provided filters. All filters are optional and combined with AND. 
         * @summary Search tasks with filters and pagination
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {string} [createdByUserId] Twórca zadania
         * @param {string} [assigneeUserId] Dla kogo zadanie
         * @param {Array<TaskStatusDto>} [status] Filtr wielowartościowy. Wynik &#x3D; OR po podanych statusach.
         * @param {TaskTriggerDto} [trigger] Trigger, który utworzył zadanie
         * @param {TaskTriggerDto} [autoCloseTrigger] Trigger, który automatycznie zamyka zadanie
         * @param {string} [targetResourceValue] Wartość ResourceId celu zadania (musi być podana razem z targetResourceType)
         * @param {ResourceTypeDto} [targetResourceType] Typ ResourceId celu zadania
         * @param {string} [searchPhrase] Filtr po opisie (częściowy, case-insensitive)
         * @param {boolean} [overdue] Gdy true, zwraca tylko zadania po terminie (deadline przed dzisiaj) w statusie aktywnym (OPEN/IN_PROGRESS).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTasks: async (page?: number, pageSize?: number, sortOrder?: SortDirectionDto, createdByUserId?: string, assigneeUserId?: string, status?: Array<TaskStatusDto>, trigger?: TaskTriggerDto, autoCloseTrigger?: TaskTriggerDto, targetResourceValue?: string, targetResourceType?: ResourceTypeDto, searchPhrase?: string, overdue?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (createdByUserId !== undefined) {
                localVarQueryParameter['createdByUserId'] = createdByUserId;
            }

            if (assigneeUserId !== undefined) {
                localVarQueryParameter['assigneeUserId'] = assigneeUserId;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (trigger !== undefined) {
                localVarQueryParameter['trigger'] = trigger;
            }

            if (autoCloseTrigger !== undefined) {
                localVarQueryParameter['autoCloseTrigger'] = autoCloseTrigger;
            }

            if (targetResourceValue !== undefined) {
                localVarQueryParameter['targetResourceValue'] = targetResourceValue;
            }

            if (targetResourceType !== undefined) {
                localVarQueryParameter['targetResourceType'] = targetResourceType;
            }

            if (searchPhrase !== undefined) {
                localVarQueryParameter['searchPhrase'] = searchPhrase;
            }

            if (overdue !== undefined) {
                localVarQueryParameter['overdue'] = overdue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TasksApi - functional programming interface
 * @export
 */
export const TasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration)
    return {
        /**
         * Zmienia status zadania i dopisuje wpis do historii (kto, kiedy, poprzedni→nowy, opcjonalny komentarz). 
         * @summary Change task status
         * @param {number} taskId 
         * @param {ChangeTaskStatusRequestDto} changeTaskStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeTaskStatus(taskId: number, changeTaskStatusRequestDto: ChangeTaskStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeTaskStatus(taskId, changeTaskStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.changeTaskStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a task
         * @param {CreateTaskRequestDto} createTaskRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTask(createTaskRequestDto: CreateTaskRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTask(createTaskRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.createTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a task
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTask(taskId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTask(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.deleteTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get task detail
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskById(taskId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskById(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getTaskById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get task status change history
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskStatusHistory(taskId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskStatusChangeDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskStatusHistory(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getTaskStatusHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of tasks matching the provided filters. All filters are optional and combined with AND. 
         * @summary Search tasks with filters and pagination
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {string} [createdByUserId] Twórca zadania
         * @param {string} [assigneeUserId] Dla kogo zadanie
         * @param {Array<TaskStatusDto>} [status] Filtr wielowartościowy. Wynik &#x3D; OR po podanych statusach.
         * @param {TaskTriggerDto} [trigger] Trigger, który utworzył zadanie
         * @param {TaskTriggerDto} [autoCloseTrigger] Trigger, który automatycznie zamyka zadanie
         * @param {string} [targetResourceValue] Wartość ResourceId celu zadania (musi być podana razem z targetResourceType)
         * @param {ResourceTypeDto} [targetResourceType] Typ ResourceId celu zadania
         * @param {string} [searchPhrase] Filtr po opisie (częściowy, case-insensitive)
         * @param {boolean} [overdue] Gdy true, zwraca tylko zadania po terminie (deadline przed dzisiaj) w statusie aktywnym (OPEN/IN_PROGRESS).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTasks(page?: number, pageSize?: number, sortOrder?: SortDirectionDto, createdByUserId?: string, assigneeUserId?: string, status?: Array<TaskStatusDto>, trigger?: TaskTriggerDto, autoCloseTrigger?: TaskTriggerDto, targetResourceValue?: string, targetResourceType?: ResourceTypeDto, searchPhrase?: string, overdue?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTasks(page, pageSize, sortOrder, createdByUserId, assigneeUserId, status, trigger, autoCloseTrigger, targetResourceValue, targetResourceType, searchPhrase, overdue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.searchTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TasksApi - factory interface
 * @export
 */
export const TasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TasksApiFp(configuration)
    return {
        /**
         * Zmienia status zadania i dopisuje wpis do historii (kto, kiedy, poprzedni→nowy, opcjonalny komentarz). 
         * @summary Change task status
         * @param {number} taskId 
         * @param {ChangeTaskStatusRequestDto} changeTaskStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeTaskStatus(taskId: number, changeTaskStatusRequestDto: ChangeTaskStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TaskDetailDto> {
            return localVarFp.changeTaskStatus(taskId, changeTaskStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a task
         * @param {CreateTaskRequestDto} createTaskRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(createTaskRequestDto: CreateTaskRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TaskDetailDto> {
            return localVarFp.createTask(createTaskRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a task
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTask(taskId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTask(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get task detail
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskById(taskId: number, options?: RawAxiosRequestConfig): AxiosPromise<TaskDetailDto> {
            return localVarFp.getTaskById(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get task status change history
         * @param {number} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskStatusHistory(taskId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskStatusChangeDto>> {
            return localVarFp.getTaskStatusHistory(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of tasks matching the provided filters. All filters are optional and combined with AND. 
         * @summary Search tasks with filters and pagination
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {string} [createdByUserId] Twórca zadania
         * @param {string} [assigneeUserId] Dla kogo zadanie
         * @param {Array<TaskStatusDto>} [status] Filtr wielowartościowy. Wynik &#x3D; OR po podanych statusach.
         * @param {TaskTriggerDto} [trigger] Trigger, który utworzył zadanie
         * @param {TaskTriggerDto} [autoCloseTrigger] Trigger, który automatycznie zamyka zadanie
         * @param {string} [targetResourceValue] Wartość ResourceId celu zadania (musi być podana razem z targetResourceType)
         * @param {ResourceTypeDto} [targetResourceType] Typ ResourceId celu zadania
         * @param {string} [searchPhrase] Filtr po opisie (częściowy, case-insensitive)
         * @param {boolean} [overdue] Gdy true, zwraca tylko zadania po terminie (deadline przed dzisiaj) w statusie aktywnym (OPEN/IN_PROGRESS).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTasks(page?: number, pageSize?: number, sortOrder?: SortDirectionDto, createdByUserId?: string, assigneeUserId?: string, status?: Array<TaskStatusDto>, trigger?: TaskTriggerDto, autoCloseTrigger?: TaskTriggerDto, targetResourceValue?: string, targetResourceType?: ResourceTypeDto, searchPhrase?: string, overdue?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<TaskListResponseDto> {
            return localVarFp.searchTasks(page, pageSize, sortOrder, createdByUserId, assigneeUserId, status, trigger, autoCloseTrigger, targetResourceValue, targetResourceType, searchPhrase, overdue, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TasksApi - interface
 * @export
 * @interface TasksApi
 */
export interface TasksApiInterface {
    /**
     * Zmienia status zadania i dopisuje wpis do historii (kto, kiedy, poprzedni→nowy, opcjonalny komentarz). 
     * @summary Change task status
     * @param {number} taskId 
     * @param {ChangeTaskStatusRequestDto} changeTaskStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    changeTaskStatus(taskId: number, changeTaskStatusRequestDto: ChangeTaskStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TaskDetailDto>;

    /**
     * 
     * @summary Create a task
     * @param {CreateTaskRequestDto} createTaskRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    createTask(createTaskRequestDto: CreateTaskRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<TaskDetailDto>;

    /**
     * 
     * @summary Delete a task
     * @param {number} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    deleteTask(taskId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get task detail
     * @param {number} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    getTaskById(taskId: number, options?: RawAxiosRequestConfig): AxiosPromise<TaskDetailDto>;

    /**
     * 
     * @summary Get task status change history
     * @param {number} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    getTaskStatusHistory(taskId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskStatusChangeDto>>;

    /**
     * Returns paginated list of tasks matching the provided filters. All filters are optional and combined with AND. 
     * @summary Search tasks with filters and pagination
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {string} [createdByUserId] Twórca zadania
     * @param {string} [assigneeUserId] Dla kogo zadanie
     * @param {Array<TaskStatusDto>} [status] Filtr wielowartościowy. Wynik &#x3D; OR po podanych statusach.
     * @param {TaskTriggerDto} [trigger] Trigger, który utworzył zadanie
     * @param {TaskTriggerDto} [autoCloseTrigger] Trigger, który automatycznie zamyka zadanie
     * @param {string} [targetResourceValue] Wartość ResourceId celu zadania (musi być podana razem z targetResourceType)
     * @param {ResourceTypeDto} [targetResourceType] Typ ResourceId celu zadania
     * @param {string} [searchPhrase] Filtr po opisie (częściowy, case-insensitive)
     * @param {boolean} [overdue] Gdy true, zwraca tylko zadania po terminie (deadline przed dzisiaj) w statusie aktywnym (OPEN/IN_PROGRESS).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    searchTasks(page?: number, pageSize?: number, sortOrder?: SortDirectionDto, createdByUserId?: string, assigneeUserId?: string, status?: Array<TaskStatusDto>, trigger?: TaskTriggerDto, autoCloseTrigger?: TaskTriggerDto, targetResourceValue?: string, targetResourceType?: ResourceTypeDto, searchPhrase?: string, overdue?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<TaskListResponseDto>;

}

/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
export class TasksApi extends BaseAPI implements TasksApiInterface {
    /**
     * Zmienia status zadania i dopisuje wpis do historii (kto, kiedy, poprzedni→nowy, opcjonalny komentarz). 
     * @summary Change task status
     * @param {number} taskId 
     * @param {ChangeTaskStatusRequestDto} changeTaskStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public changeTaskStatus(taskId: number, changeTaskStatusRequestDto: ChangeTaskStatusRequestDto, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).changeTaskStatus(taskId, changeTaskStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a task
     * @param {CreateTaskRequestDto} createTaskRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public createTask(createTaskRequestDto: CreateTaskRequestDto, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).createTask(createTaskRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a task
     * @param {number} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public deleteTask(taskId: number, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).deleteTask(taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get task detail
     * @param {number} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getTaskById(taskId: number, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getTaskById(taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get task status change history
     * @param {number} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public getTaskStatusHistory(taskId: number, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getTaskStatusHistory(taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of tasks matching the provided filters. All filters are optional and combined with AND. 
     * @summary Search tasks with filters and pagination
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {string} [createdByUserId] Twórca zadania
     * @param {string} [assigneeUserId] Dla kogo zadanie
     * @param {Array<TaskStatusDto>} [status] Filtr wielowartościowy. Wynik &#x3D; OR po podanych statusach.
     * @param {TaskTriggerDto} [trigger] Trigger, który utworzył zadanie
     * @param {TaskTriggerDto} [autoCloseTrigger] Trigger, który automatycznie zamyka zadanie
     * @param {string} [targetResourceValue] Wartość ResourceId celu zadania (musi być podana razem z targetResourceType)
     * @param {ResourceTypeDto} [targetResourceType] Typ ResourceId celu zadania
     * @param {string} [searchPhrase] Filtr po opisie (częściowy, case-insensitive)
     * @param {boolean} [overdue] Gdy true, zwraca tylko zadania po terminie (deadline przed dzisiaj) w statusie aktywnym (OPEN/IN_PROGRESS).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    public searchTasks(page?: number, pageSize?: number, sortOrder?: SortDirectionDto, createdByUserId?: string, assigneeUserId?: string, status?: Array<TaskStatusDto>, trigger?: TaskTriggerDto, autoCloseTrigger?: TaskTriggerDto, targetResourceValue?: string, targetResourceType?: ResourceTypeDto, searchPhrase?: string, overdue?: boolean, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).searchTasks(page, pageSize, sortOrder, createdByUserId, assigneeUserId, status, trigger, autoCloseTrigger, targetResourceValue, targetResourceType, searchPhrase, overdue, options).then((request) => request(this.axios, this.basePath));
    }
}

